import { KnownProjectDtoProjectType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryGetProjectOptional } from '../../../../core/queries/projects.queries';

// Label used for a column when the project type has no override below.
const DEFAULT_COLUMN_NAMES = {
  GROUP: 'Group',
  PROJECT: 'Project',
  STATUS: '',
  GROUP_PERMISSION: ''
} as const;

export type UsersColumnName = keyof typeof DEFAULT_COLUMN_NAMES;

// Only the project types that differ from the default need an entry here.
const usersColumnNameOverrides: Record<UsersColumnName, Partial<Record<KnownProjectDtoProjectType, string>>> = {
  GROUP: {
    [KnownProjectDtoProjectType.CommercialBuilding]: 'Tenant',
    [KnownProjectDtoProjectType.ResidentialBuilding]: 'Unit',
    [KnownProjectDtoProjectType.Business]: 'Department'
  },
  PROJECT: {
    [KnownProjectDtoProjectType.CommercialBuilding]: 'Building',
    [KnownProjectDtoProjectType.ResidentialBuilding]: 'Building',
    [KnownProjectDtoProjectType.Business]: 'Building',
    [KnownProjectDtoProjectType.Retailer]: 'Store',
    [KnownProjectDtoProjectType.Store]: 'Store'
  },
  STATUS: {},
  GROUP_PERMISSION: {}
};

export function useUsersColumnName(projectID: string): Record<UsersColumnName, string> {
  const project = useQueryGetProjectOptional(projectID);
  const projectType = (project.data?.projectType as KnownProjectDtoProjectType) || KnownProjectDtoProjectType.Project;

  const columnNamesMap = {} as Record<UsersColumnName, string>;

  for (const columnName of Object.keys(DEFAULT_COLUMN_NAMES) as UsersColumnName[]) {
    const columnNameLabel = usersColumnNameOverrides[columnName][projectType] ?? DEFAULT_COLUMN_NAMES[columnName];
    columnNamesMap[columnName] = columnNameLabel.toUpperCase();
  }

  return columnNamesMap;
}
